import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark } from '@fortawesome/free-regular-svg-icons'
import { Tooltip } from 'react-tooltip'
import { IHeader } from '@/models/IHeader'
import { useEffect, useState } from 'react'
import { IBookmark } from '@/models/IBookmark'
import { isPageBookmarked } from '@/utils/bookmark-checker'
import { bookmarksApiService } from '@/services/bookmarks-api.services'
import { LocalStorageHelper } from '@/utils/local-storage-helper'

interface IProps {
	heading: string
	subheading?: string
	showBookmark?: boolean
	pageId?: number
}

export default function Heading(props: IProps) {
	const { heading, subheading, showBookmark, pageId } = props
	const [isBookmarked, setIsBookmarked] = useState<boolean>(false)
	const [addtoBookmarkLabel, setAddtoBookmarkLabel] = useState<string>('Add to bookmarks')
	const [isOpen, setIsOpen] = useState(false)

	const header = JSON.parse(
		localStorage.getItem('header-info') as string,
	) as IHeader

	const onBookmarkClick = async () => {
		setIsOpen(false)
		if (header) {
			const { memberId } = header
			if (!isBookmarked) {
				await bookmarksApiService.addBookmark(memberId, pageId ?? 0)
				setTimeout(() => {
					setIsBookmarked(true)
					setIsOpen(false)
				}, 2000)
				setAddtoBookmarkLabel('Added to bookmarks')
				setIsOpen(true)
			} else {
				await bookmarksApiService.deleteBookmark(memberId, pageId ?? 0)
				setIsBookmarked(false)
				setAddtoBookmarkLabel('Add to bookmarks')
			}
		} else {
			// TODO: handle error
		}
	}

	useEffect(() => {
		if (header) {
			const bookmarks = LocalStorageHelper.getItem<IBookmark[]>(`bookmarks-${header.memberId}`);
			if (bookmarks) {
				setIsBookmarked(isPageBookmarked(pageId ?? 0))
			}
		}
	}, [isBookmarked])

	return (
		<div className="w-full bg-white justify-center items-center gap-5 inline-flex mt-14">
			<div className="grow shrink basis-0 pr-4 flex-col justify-start placeholder:gap-4 inline-flex items-start">
				<div className="flex justify-between items-center xs:flex-wrap gap-4 w-full">
					<div className='md:w-auto w-full'>
						<h1 className="grow shrink m-0 text-sky-800 md:text-[64px] md:leading-[70px] text-[52px] leading-[60px] capitalize">
							{heading}
						</h1>
						{subheading && (
							<p className="w-full font-museo text-text-color-100 mt-2 mb-0 text-xl font-normal">
								{subheading}
							</p>
						)}
					</div>
					{showBookmark && (
						<>
							<button
								onClick={onBookmarkClick}
								className={
									isBookmarked
										? 'p-[18px] bg-sky-800 rounded-[60px] border border-sky-800 text-text-color-0 justify-center items-center gap-3 flex md:w-auto'
										: 'p-[18px] bg-yellow-400 rounded-[60px] border border-yellow-400 justify-center items-center gap-3 flex md:w-auto'
								}
								data-tooltip-id="bookmark-save-tooltip"
								data-tooltip-content={`${isBookmarked ? 'Remove bookmark' : addtoBookmarkLabel}`}
								data-tooltip-place="bottom"
								data-tooltip-class-name="max-w-[250px] p-2 !rounded z-10 text-center"
								onMouseEnter={() => setIsOpen(true)}
								onMouseLeave={() => setIsOpen(false)}
							>
								<FontAwesomeIcon
									icon={faBookmark}
									className={'w-[18px] h-[18px]'}
								/>
							</button>
							<Tooltip
								id="bookmark-save-tooltip"
								isOpen={isOpen}
							/>
						</>
					)}

				</div>
			</div>
		</div>
	)
}
